module.exports = __webpack_public_path__ + "static/img/bottom-button-1-down.7ecc1ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/bottom-button-1-down.png
// module id = fmr8
// module chunks = 1